import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServiceSection from '../components/ServiceSection';
import ProjectSection from '../components/ProjectSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ContactBanner from '../components/ContactBanner';

const Home = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div>
      <HeroSection />
      <Zoom>
        <AboutSection />
      </Zoom>
      <Fade bottom>
        <ServiceSection />
      </Fade>
      <Fade left>
        <ProjectSection />
      </Fade>
      <Fade bottom>
        <TestimonialsSection />
      </Fade>
      <Flip top>
        <ContactBanner />
      </Flip>
    </div>
  );
};

export default Home;
